import type {
  ActivityChartRow,
  ChartQueryOpts,
  ChartRow,
  SportKey,
} from "@/types/chart.types";
import { rowsToChartData } from "@/utils/chart.utils";
import { applyBasicFilters } from "@/utils/demo.utils";
import { loadDemoActivities } from "./demoStore";

async function fetchChartActivitiesDemo(
  q: ChartQueryOpts,
): Promise<ActivityChartRow[]> {
  const { metric } = q;
  const all = await loadDemoActivities();
  const rows = applyBasicFilters(all, q);
  return rows.map((a) => {
    const row: any = {
      start_date: a.start_date,
      sport_type: a.sport_type,
      type: a.type,
      name: a.name,
    };
    row[metric] = metric === "count" ? 1 : a[metric];
    return row as ActivityChartRow;
  });
}

export async function fetchChartDataDemo(opts: ChartQueryOpts): Promise<{
  chartData: ChartRow[];
  series: SportKey[];
  totalValue?: number;
}> {
  const rows = await fetchChartActivitiesDemo(opts);
  return rowsToChartData(rows, opts);
}
